import RadioGroup from '@components/v2/form/RadioGroup/RadioGroup';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { CatalogProductsTestIds } from '../../../../../../../utils/testIds/CatalogProducts.testIds';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface CatalogViewFreezeArrangementChoiceProps {
  isFreezingArrangement: boolean;
  onChange: (isFreezingArrangement: boolean) => void;
}

const FREEZE_VALUE = 'freeze';
const KEEP_VALUE = 'keep';

const FREEZE_ARRANGEMENT_OPTIONS = [
  {
    value: KEEP_VALUE,
    label: LangEnum.CATALOGS_VIEW_FREEZE_ARRANGEMENT_KEEP,
    hint: LangEnum.CATALOGS_VIEW_FREEZE_ARRANGEMENT_KEEP_HINT,
  },
  {
    value: FREEZE_VALUE,
    label: LangEnum.CATALOGS_VIEW_FREEZE_ARRANGEMENT_SNAPSHOT,
    hint: LangEnum.CATALOGS_VIEW_FREEZE_ARRANGEMENT_SNAPSHOT_HINT,
  },
];

const CatalogViewFreezeArrangementChoice = ({
  isFreezingArrangement,
  onChange,
}: CatalogViewFreezeArrangementChoiceProps) => {
  const { translate } = useTranslation();

  const options = FREEZE_ARRANGEMENT_OPTIONS.map((option) => ({
    value: option.value,
    label: (
      <Stack>
        <Typography variant="body2">{translate(option.label)}</Typography>
        <Typography variant="caption" color="text.secondary">
          {translate(option.hint)}
        </Typography>
      </Stack>
    ),
  }));

  return (
    <RadioGroup
      column
      name="catalog-view-freeze-arrangement"
      value={isFreezingArrangement ? FREEZE_VALUE : KEEP_VALUE}
      options={options}
      label={translate(LangEnum.CATALOGS_VIEW_FREEZE_ARRANGEMENT_CHOICE_LABEL)}
      testId={CatalogProductsTestIds.VIEW_FREEZE_ARRANGEMENT_CHOICE}
      onChange={(value) => onChange(value === FREEZE_VALUE)}
    />
  );
};

export default CatalogViewFreezeArrangementChoice;
